import { createRouter, createWebHistory } from 'vue-router'
import InfoView from '../views/InfoView.vue'
import TimeTableView from '../views/TimeTableView.vue'
import GroupRankView from '../views/GroupRankView.vue'
import LoginView from '../views/LoginView.vue'
import OpsMenuView from '../views/OpsMenuView'
import EntryByEventView from '../views/EntryByEventView.vue'
import EntryByTeamView from '../views/EntryByTeamView.vue'
import ListViewSample from '../views/ListViewSample.vue'
import TimeTableCardView from '../views/TimeTableCardView.vue'
import TimeTableGridView from '../views/TimeTableGridView.vue'
import MatchFinishView from '../views/MatchFinishView.vue'
import MatchStartView from '../views/MatchStartView.vue'
import MatchCardView from '../views/MatchCardView.vue'

import { getAuth, onAuthStateChanged } from "firebase/auth";

const routes = [
  {
    path: '/',
    name: 'home',
    component: InfoView,
    meta: { title: "ホーム", requiresAuth: false }
  },
  {
    path: '/match/list',
    name: 'list',
    component: TimeTableView,
    meta: { title: "試合", requiresAuth: false }
  },
  {
    path: '/match',
    name: 'matchCard',
    component: TimeTableCardView,
    meta: { title: "試合カード", requiresAuth: false }
  },
  {
    path: '/match/:match_id',
    name: 'matchCardDetail',
    component: MatchCardView,
    meta: { title: "試合詳細", requiresAuth: false }
  },
  {
    path: '/timetable',
    name: 'timetable',
    component: TimeTableGridView,
    meta: { title: "タイムテーブル", requiresAuth: false }
  },
  {
    path: '/sample',
    name: 'sample',
    component: ListViewSample,
    meta: { title: "Sample", requiresAuth: false }
  },
  {
    path: '/rank',
    name: 'rank',
    component: GroupRankView,
    meta: { title: "順位", requiresAuth: false }
  },
  {
    path: '/entry/event',
    name: 'entry/event',
    component: EntryByEventView,
    meta: { title: "エントリ", requiresAuth: false }
  },
  {
    path: '/entry/team',
    name: 'entry/team',
    component: EntryByTeamView,
    meta: { title: "参加一覧", requiresAuth: false }
  },
  {
    path: '/match/start',
    name: 'matchStart',
    component: MatchStartView,
    meta: { title: "試合開始", requiresAuth: true }
  },
  {
    path: '/match/finish',
    name: 'matchFinish',
    component: MatchFinishView,
    meta: { title: "試合結果入力", requiresAuth: true }
  },
  {
    path: '/ops/login',
    name: 'login',
    component: LoginView,
    meta: { title: "ログイン", requiresAuth: false }
  },
  {
    path: '/ops/menu',
    name: 'menu',
    component: OpsMenuView,
    meta: { title: "管理メニュー", requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const auth = getAuth()

  if (!to.matched.some(record => record.meta.requiresAuth)) {
    next()
  } else {
    if (auth.currentUser) {
      next()
      return
    } else {
      if (typeof onAuthStateChangedUnsubscribe === 'function') {
        onAuthStateChangedUnsubscribe()
      }
      onAuthStateChanged(auth, (user) => {
        if (user) {
          next()
        } else {
          next({ name: 'login' })
        }
      })
    }
  }
})

router.afterEach((to) => {
  document.title = "草加市小学生バド大会 " + to.meta.title
})



export default router
